import { useState } from 'react'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import {
  BUTTONS,
  ProSlideIndex,
  proCarouselItems,
  TeamSlideIndex,
  teamCarouselItems,
} from './constants'
import type { PlanType, ProSlideType, TeamSlideType } from './types'

export const useUpgradePlanModal = (
  planType: PlanType = 'pro',
  slideType?: ProSlideType | TeamSlideType
) => {
  const initialSlideIndex = (() => {
    if (!slideType) {
      return 0
    }

    if (planType === 'pro') {
      return ProSlideIndex[slideType as ProSlideType]
    }

    return TeamSlideIndex[slideType as TeamSlideType]
  })()

  const [plan, setPlan] = useState<PlanType>(planType)
  const [activeSlideIndex, setActiveSlideIndex] =
    useState<number>(initialSlideIndex)

  const carouselItems = plan === 'pro' ? proCarouselItems : teamCarouselItems

  const defaultIndex = BUTTONS.findIndex(
    (segment) => segment.value === planType
  )

  const handleSetPlan = (planType: PlanType) => {
    setPlan(planType)
    setActiveSlideIndex(0)
  }

  const handleClickCarousel = (index: number) => {
    sendGtmEvent(GtmTriggerName.UPGRADE_CAROUSEL)
    setActiveSlideIndex(index)
  }

  const handleClickFeatures = (index: number) => {
    sendGtmEvent(GtmTriggerName.UPGRADE_LIST)
    setActiveSlideIndex(index)
  }

  return {
    plan,
    carouselItems,
    activeSlideIndex,
    buttons: BUTTONS,
    defaultIndex,
    handleSetPlan,
    handleClickCarousel,
    handleClickFeatures,
  }
}
